var cov_2kmh2wqkio = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Thead.tsx",
      hash = "6b6ae37e7f5c9bb39acf25d7394ab35c2613c9dd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Thead.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 12,
          column: 28
        }
      },
      "1": {
        start: {
          line: 13,
          column: 28
        },
        end: {
          line: 13,
          column: 30
        }
      },
      "2": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 16
        }
      },
      "3": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 68
        }
      },
      "4": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 68
        }
      },
      "5": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 64
        }
      },
      "6": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "7": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 23
        }
      },
      "8": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 14
        }
      },
      "9": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 58
        }
      },
      "10": {
        start: {
          line: 52,
          column: 34
        },
        end: {
          line: 52,
          column: 58
        }
      },
      "11": {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 53,
          column: 64
        }
      },
      "12": {
        start: {
          line: 54,
          column: 17
        },
        end: {
          line: 54,
          column: 69
        }
      },
      "13": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "14": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 23
        }
      },
      "15": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 14
        }
      },
      "16": {
        start: {
          line: 61,
          column: 18
        },
        end: {
          line: 61,
          column: 19
        }
      },
      "17": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      "18": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 68
        }
      },
      "19": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 29
        }
      },
      "20": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 43
        }
      },
      "21": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 43
        }
      },
      "22": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "23": {
        start: {
          line: 66,
          column: 25
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "24": {
        start: {
          line: 68,
          column: 18
        },
        end: {
          line: 68,
          column: 47
        }
      },
      "25": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 59
        }
      },
      "26": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 28
        }
      },
      "27": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 82,
          column: 8
        }
      },
      "28": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 18
        }
      },
      "29": {
        start: {
          line: 89,
          column: 24
        },
        end: {
          line: 89,
          column: 34
        }
      },
      "30": {
        start: {
          line: 90,
          column: 17
        },
        end: {
          line: 90,
          column: 44
        }
      },
      "31": {
        start: {
          line: 91,
          column: 35
        },
        end: {
          line: 91,
          column: 39
        }
      },
      "32": {
        start: {
          line: 92,
          column: 17
        },
        end: {
          line: 92,
          column: 59
        }
      },
      "33": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "34": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 60
        }
      },
      "35": {
        start: {
          line: 96,
          column: 12
        },
        end: {
          line: 96,
          column: 27
        }
      },
      "36": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "37": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 31
        }
      },
      "38": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 42
        }
      },
      "39": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "40": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 31
        }
      },
      "41": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 43
        }
      },
      "42": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "43": {
        start: {
          line: 111,
          column: 21
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "44": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 77
        }
      },
      "45": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 73
        }
      },
      "46": {
        start: {
          line: 114,
          column: 21
        },
        end: {
          line: 114,
          column: 54
        }
      },
      "47": {
        start: {
          line: 116,
          column: 24
        },
        end: {
          line: 116,
          column: 64
        }
      },
      "48": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 122,
          column: 13
        }
      },
      "49": {
        start: {
          line: 120,
          column: 24
        },
        end: {
          line: 120,
          column: 63
        }
      },
      "50": {
        start: {
          line: 121,
          column: 10
        },
        end: {
          line: 121,
          column: 30
        }
      },
      "51": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 87
        }
      },
      "52": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 62
        }
      },
      "53": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 64
        }
      },
      "54": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 126,
          column: 66
        }
      },
      "55": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 62
        }
      },
      "56": {
        start: {
          line: 128,
          column: 11
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "57": {
        start: {
          line: 129,
          column: 16
        },
        end: {
          line: 129,
          column: 25
        }
      },
      "58": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 133,
          column: 7
        }
      },
      "59": {
        start: {
          line: 131,
          column: 23
        },
        end: {
          line: 131,
          column: 37
        }
      },
      "60": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 35
        }
      },
      "61": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 20
        }
      },
      "62": {
        start: {
          line: 135,
          column: 11
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "63": {
        start: {
          line: 136,
          column: 40
        },
        end: {
          line: 136,
          column: 50
        }
      },
      "64": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 137,
          column: 69
        }
      },
      "65": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 65
        }
      },
      "66": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 65
        }
      },
      "67": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 67
        }
      },
      "68": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 28
        }
      },
      "69": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 108
        }
      },
      "70": {
        start: {
          line: 142,
          column: 23
        },
        end: {
          line: 142,
          column: 108
        }
      },
      "71": {
        start: {
          line: 147,
          column: 32
        },
        end: {
          line: 147,
          column: 42
        }
      },
      "72": {
        start: {
          line: 148,
          column: 20
        },
        end: {
          line: 148,
          column: 56
        }
      },
      "73": {
        start: {
          line: 149,
          column: 21
        },
        end: {
          line: 149,
          column: 49
        }
      },
      "74": {
        start: {
          line: 150,
          column: 18
        },
        end: {
          line: 150,
          column: 20
        }
      },
      "75": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 51
        }
      },
      "76": {
        start: {
          line: 151,
          column: 19
        },
        end: {
          line: 151,
          column: 51
        }
      },
      "77": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 49
        }
      },
      "78": {
        start: {
          line: 152,
          column: 24
        },
        end: {
          line: 152,
          column: 49
        }
      },
      "79": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 47
        }
      },
      "80": {
        start: {
          line: 153,
          column: 23
        },
        end: {
          line: 153,
          column: 47
        }
      },
      "81": {
        start: {
          line: 155,
          column: 106
        },
        end: {
          line: 155,
          column: 116
        }
      },
      "82": {
        start: {
          line: 156,
          column: 20
        },
        end: {
          line: 156,
          column: 42
        }
      },
      "83": {
        start: {
          line: 157,
          column: 18
        },
        end: {
          line: 157,
          column: 59
        }
      },
      "84": {
        start: {
          line: 158,
          column: 30
        },
        end: {
          line: 158,
          column: 86
        }
      },
      "85": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 162,
          column: 14
        }
      },
      "86": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 191,
          column: 5
        }
      },
      "87": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 188,
          column: 7
        }
      },
      "88": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 190,
          column: 12
        }
      },
      "89": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 212,
          column: 5
        }
      },
      "90": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 210,
          column: 7
        }
      },
      "91": {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 12
        }
      },
      "92": {
        start: {
          line: 214,
          column: 18
        },
        end: {
          line: 214,
          column: 80
        }
      },
      "93": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 228,
          column: 5
        }
      },
      "94": {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 232,
          column: 5
        }
      },
      "95": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 69
        }
      },
      "96": {
        start: {
          line: 231,
          column: 36
        },
        end: {
          line: 231,
          column: 68
        }
      },
      "97": {
        start: {
          line: 236,
          column: 24
        },
        end: {
          line: 236,
          column: 55
        }
      },
      "98": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 45
        }
      },
      "99": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 104
        }
      },
      "100": {
        start: {
          line: 238,
          column: 29
        },
        end: {
          line: 238,
          column: 104
        }
      },
      "101": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 24
        }
      },
      "102": {
        start: {
          line: 243,
          column: 45
        },
        end: {
          line: 243,
          column: 47
        }
      },
      "103": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 246,
          column: 6
        }
      },
      "104": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 45
        }
      },
      "105": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 31
        }
      },
      "106": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 251,
          column: 5
        }
      },
      "107": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 250,
          column: 57
        }
      },
      "108": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 252,
          column: 18
        }
      },
      "109": {
        start: {
          line: 256,
          column: 20
        },
        end: {
          line: 256,
          column: 40
        }
      },
      "110": {
        start: {
          line: 257,
          column: 34
        },
        end: {
          line: 257,
          column: 36
        }
      },
      "111": {
        start: {
          line: 258,
          column: 4
        },
        end: {
          line: 260,
          column: 5
        }
      },
      "112": {
        start: {
          line: 259,
          column: 6
        },
        end: {
          line: 259,
          column: 18
        }
      },
      "113": {
        start: {
          line: 261,
          column: 4
        },
        end: {
          line: 261,
          column: 54
        }
      },
      "114": {
        start: {
          line: 261,
          column: 27
        },
        end: {
          line: 261,
          column: 53
        }
      },
      "115": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 14
        }
      },
      "116": {
        start: {
          line: 266,
          column: 16
        },
        end: {
          line: 266,
          column: 32
        }
      },
      "117": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 274,
          column: 5
        }
      },
      "118": {
        start: {
          line: 271,
          column: 10
        },
        end: {
          line: 271,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 50
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 39
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        loc: {
          start: {
            line: 46,
            column: 109
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 3
          }
        },
        loc: {
          start: {
            line: 88,
            column: 33
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 88
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 75
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 109
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 119,
            column: 16
          },
          end: {
            line: 119,
            column: 17
          }
        },
        loc: {
          start: {
            line: 119,
            column: 67
          },
          end: {
            line: 122,
            column: 9
          }
        },
        line: 119
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 77
          },
          end: {
            line: 233,
            column: 3
          }
        },
        line: 146
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 231,
            column: 31
          },
          end: {
            line: 231,
            column: 32
          }
        },
        loc: {
          start: {
            line: 231,
            column: 36
          },
          end: {
            line: 231,
            column: 68
          }
        },
        line: 231
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 235,
            column: 2
          },
          end: {
            line: 235,
            column: 3
          }
        },
        loc: {
          start: {
            line: 235,
            column: 51
          },
          end: {
            line: 239,
            column: 3
          }
        },
        line: 235
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 241,
            column: 2
          },
          end: {
            line: 241,
            column: 3
          }
        },
        loc: {
          start: {
            line: 241,
            column: 18
          },
          end: {
            line: 253,
            column: 3
          }
        },
        line: 241
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 244,
            column: 31
          },
          end: {
            line: 244,
            column: 32
          }
        },
        loc: {
          start: {
            line: 244,
            column: 47
          },
          end: {
            line: 246,
            column: 5
          }
        },
        line: 244
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 255,
            column: 3
          }
        },
        loc: {
          start: {
            line: 255,
            column: 14
          },
          end: {
            line: 263,
            column: 3
          }
        },
        line: 255
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 261,
            column: 20
          },
          end: {
            line: 261,
            column: 21
          }
        },
        loc: {
          start: {
            line: 261,
            column: 27
          },
          end: {
            line: 261,
            column: 53
          }
        },
        line: 261
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 265,
            column: 2
          },
          end: {
            line: 265,
            column: 3
          }
        },
        loc: {
          start: {
            line: 265,
            column: 11
          },
          end: {
            line: 275,
            column: 3
          }
        },
        line: 265
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 270,
            column: 17
          },
          end: {
            line: 270,
            column: 18
          }
        },
        loc: {
          start: {
            line: 271,
            column: 10
          },
          end: {
            line: 271,
            column: 31
          }
        },
        line: 271
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 46,
            column: 98
          },
          end: {
            line: 46,
            column: 107
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 46,
            column: 106
          },
          end: {
            line: 46,
            column: 107
          }
        }],
        line: 46
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 58
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 58
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 53,
            column: 14
          },
          end: {
            line: 53,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 41
          },
          end: {
            line: 53,
            column: 50
          }
        }, {
          start: {
            line: 53,
            column: 53
          },
          end: {
            line: 53,
            column: 64
          }
        }],
        line: 53
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }],
        line: 62
      },
      "6": {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 12
          }
        }, {
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 38
          }
        }],
        line: 62
      },
      "7": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 43
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 43
          }
        }],
        line: 65
      },
      "8": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        }, {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        }],
        line: 66
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 76,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 14
          },
          end: {
            line: 75,
            column: 36
          }
        }, {
          start: {
            line: 76,
            column: 14
          },
          end: {
            line: 76,
            column: 84
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 14
          },
          end: {
            line: 76,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 14
          },
          end: {
            line: 76,
            column: 35
          }
        }, {
          start: {
            line: 76,
            column: 39
          },
          end: {
            line: 76,
            column: 84
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 93
      },
      "12": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 28
          }
        }, {
          start: {
            line: 93,
            column: 32
          },
          end: {
            line: 93,
            column: 44
          }
        }],
        line: 93
      },
      "13": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        }, {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        }],
        line: 97
      },
      "14": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 103
      },
      "15": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        }],
        line: 110
      },
      "16": {
        loc: {
          start: {
            line: 120,
            column: 24
          },
          end: {
            line: 120,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 24
          },
          end: {
            line: 120,
            column: 58
          }
        }, {
          start: {
            line: 120,
            column: 62
          },
          end: {
            line: 120,
            column: 63
          }
        }],
        line: 120
      },
      "17": {
        loc: {
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        }, {
          start: {
            line: 128,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        }],
        line: 128
      },
      "18": {
        loc: {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        }],
        line: 130
      },
      "19": {
        loc: {
          start: {
            line: 135,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        }, {
          start: {
            line: 135,
            column: 11
          },
          end: {
            line: 143,
            column: 5
          }
        }],
        line: 135
      },
      "20": {
        loc: {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 108
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 108
          }
        }, {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 108
          }
        }],
        line: 142
      },
      "21": {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 51
          }
        }, {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 151,
            column: 51
          }
        }],
        line: 151
      },
      "22": {
        loc: {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 49
          }
        }, {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 152,
            column: 49
          }
        }],
        line: 152
      },
      "23": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 47
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 153,
            column: 47
          }
        }],
        line: 153
      },
      "24": {
        loc: {
          start: {
            line: 156,
            column: 22
          },
          end: {
            line: 156,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 22
          },
          end: {
            line: 156,
            column: 26
          }
        }, {
          start: {
            line: 156,
            column: 30
          },
          end: {
            line: 156,
            column: 41
          }
        }],
        line: 156
      },
      "25": {
        loc: {
          start: {
            line: 157,
            column: 18
          },
          end: {
            line: 157,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 18
          },
          end: {
            line: 157,
            column: 31
          }
        }, {
          start: {
            line: 157,
            column: 35
          },
          end: {
            line: 157,
            column: 59
          }
        }],
        line: 157
      },
      "26": {
        loc: {
          start: {
            line: 158,
            column: 30
          },
          end: {
            line: 158,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 30
          },
          end: {
            line: 158,
            column: 61
          }
        }, {
          start: {
            line: 158,
            column: 65
          },
          end: {
            line: 158,
            column: 86
          }
        }],
        line: 158
      },
      "27": {
        loc: {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 162,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 161,
            column: 92
          }
        }, {
          start: {
            line: 162,
            column: 10
          },
          end: {
            line: 162,
            column: 14
          }
        }],
        line: 160
      },
      "28": {
        loc: {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 160,
            column: 116
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 160,
            column: 17
          }
        }, {
          start: {
            line: 160,
            column: 21
          },
          end: {
            line: 160,
            column: 29
          }
        }, {
          start: {
            line: 160,
            column: 33
          },
          end: {
            line: 160,
            column: 48
          }
        }, {
          start: {
            line: 160,
            column: 52
          },
          end: {
            line: 160,
            column: 116
          }
        }],
        line: 160
      },
      "29": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        }],
        line: 163
      },
      "30": {
        loc: {
          start: {
            line: 167,
            column: 23
          },
          end: {
            line: 167,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 23
          },
          end: {
            line: 167,
            column: 32
          }
        }, {
          start: {
            line: 167,
            column: 36
          },
          end: {
            line: 167,
            column: 47
          }
        }],
        line: 167
      },
      "31": {
        loc: {
          start: {
            line: 173,
            column: 37
          },
          end: {
            line: 173,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 173,
            column: 37
          },
          end: {
            line: 173,
            column: 51
          }
        }, {
          start: {
            line: 173,
            column: 55
          },
          end: {
            line: 173,
            column: 67
          }
        }],
        line: 173
      },
      "32": {
        loc: {
          start: {
            line: 174,
            column: 19
          },
          end: {
            line: 174,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 57
          },
          end: {
            line: 174,
            column: 76
          }
        }, {
          start: {
            line: 174,
            column: 79
          },
          end: {
            line: 174,
            column: 92
          }
        }],
        line: 174
      },
      "33": {
        loc: {
          start: {
            line: 175,
            column: 13
          },
          end: {
            line: 184,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 13
          },
          end: {
            line: 175,
            column: 27
          }
        }, {
          start: {
            line: 176,
            column: 14
          },
          end: {
            line: 183,
            column: 16
          }
        }],
        line: 175
      },
      "34": {
        loc: {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }, {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }],
        line: 193
      },
      "35": {
        loc: {
          start: {
            line: 200,
            column: 11
          },
          end: {
            line: 208,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 200,
            column: 11
          },
          end: {
            line: 200,
            column: 24
          }
        }, {
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 207,
            column: 14
          }
        }],
        line: 200
      },
      "36": {
        loc: {
          start: {
            line: 205,
            column: 31
          },
          end: {
            line: 205,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 46
          },
          end: {
            line: 205,
            column: 61
          }
        }, {
          start: {
            line: 205,
            column: 64
          },
          end: {
            line: 205,
            column: 73
          }
        }],
        line: 205
      },
      "37": {
        loc: {
          start: {
            line: 214,
            column: 18
          },
          end: {
            line: 214,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 214,
            column: 54
          },
          end: {
            line: 214,
            column: 63
          }
        }, {
          start: {
            line: 214,
            column: 66
          },
          end: {
            line: 214,
            column: 80
          }
        }],
        line: 214
      },
      "38": {
        loc: {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }, {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }],
        line: 230
      },
      "39": {
        loc: {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 104
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 104
          }
        }, {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 104
          }
        }],
        line: 238
      },
      "40": {
        loc: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        }, {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        }],
        line: 249
      },
      "41": {
        loc: {
          start: {
            line: 249,
            column: 8
          },
          end: {
            line: 249,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 249,
            column: 8
          },
          end: {
            line: 249,
            column: 26
          }
        }, {
          start: {
            line: 249,
            column: 30
          },
          end: {
            line: 249,
            column: 49
          }
        }],
        line: 249
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Thead.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { getUidStr } from '../utils/uid';
import { tableClass } from './styles';
import Sorter from './Sorter';
import CheckboxAll from './CheckboxAll';
import { getParent } from '../utils/dom/element';
import { isNumber } from '../utils/is';
var cacheGroup = (cov_2kmh2wqkio.s[0]++, new Map());
var MIN_RESIZABLE_WIDTH = (cov_2kmh2wqkio.s[1]++, 20);

var Thead =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Thead, _PureComponent);

  var _super = _createSuper2(Thead);

  function Thead(props) {
    var _this;

    _classCallCheck(this, Thead);

    cov_2kmh2wqkio.f[0]++;
    cov_2kmh2wqkio.s[2]++;
    _this = _super.call(this, props);
    _this.handleMouseDown = void 0;
    _this.handleMouseMove = void 0;
    _this.handleMouseUp = void 0;
    _this.resizingTh = void 0;
    _this.resizingTable = void 0;
    _this.columnLevel = void 0;
    _this.resizingIndex = void 0;
    _this.resizingCol = void 0;
    _this.lastX = void 0;
    _this.rightBorderRecord = void 0;
    cov_2kmh2wqkio.s[3]++;
    _this.handleMouseDown = _this.handleResize.bind(_assertThisInitialized(_this), 'mousedown');
    cov_2kmh2wqkio.s[4]++;
    _this.handleMouseMove = _this.handleResize.bind(_assertThisInitialized(_this), 'mousemove');
    cov_2kmh2wqkio.s[5]++;
    _this.handleMouseUp = _this.handleResize.bind(_assertThisInitialized(_this), 'mouseup');
    return _this;
  }

  _createClass(Thead, [{
    key: "setColumns",
    value: function setColumns(columns, col, level) {
      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_2kmh2wqkio.b[0][0]++, 0);
      cov_2kmh2wqkio.f[1]++;
      cov_2kmh2wqkio.s[6]++;

      if (!col.group) {
        cov_2kmh2wqkio.b[1][0]++;
        cov_2kmh2wqkio.s[7]++;
        columns.push(col);
        cov_2kmh2wqkio.s[8]++;
        return 1;
      } else {
        cov_2kmh2wqkio.b[1][1]++;
      }

      cov_2kmh2wqkio.s[9]++;

      if (level > this.columnLevel) {
        cov_2kmh2wqkio.b[2][0]++;
        cov_2kmh2wqkio.s[10]++;
        this.columnLevel = level;
      } else {
        cov_2kmh2wqkio.b[2][1]++;
      }

      var g = (cov_2kmh2wqkio.s[11]++, Array.isArray(col.group) ? (cov_2kmh2wqkio.b[3][0]++, col.group) : (cov_2kmh2wqkio.b[3][1]++, [col.group]));
      var last = (cov_2kmh2wqkio.s[12]++, columns[columns.length - 1]);
      cov_2kmh2wqkio.s[13]++;

      if (!g[level]) {
        cov_2kmh2wqkio.b[4][0]++;
        cov_2kmh2wqkio.s[14]++;
        columns.push(col);
        cov_2kmh2wqkio.s[15]++;
        return 1;
      } else {
        cov_2kmh2wqkio.b[4][1]++;
      }

      var colSpan = (cov_2kmh2wqkio.s[16]++, 0);
      cov_2kmh2wqkio.s[17]++;

      if ((cov_2kmh2wqkio.b[6][0]++, last) && (cov_2kmh2wqkio.b[6][1]++, last.name === g[level])) {
        cov_2kmh2wqkio.b[5][0]++;
        cov_2kmh2wqkio.s[18]++;
        colSpan = this.setColumns(last.columns, col, level + 1, index);
        cov_2kmh2wqkio.s[19]++;
        last.colSpan += colSpan;
        cov_2kmh2wqkio.s[20]++;

        if (col.fixed) {
          cov_2kmh2wqkio.b[7][0]++;
          cov_2kmh2wqkio.s[21]++;
          last.fixed = col.fixed;
        } else {
          cov_2kmh2wqkio.b[7][1]++;
        }

        cov_2kmh2wqkio.s[22]++;

        if (col.lastFixed) {
          cov_2kmh2wqkio.b[8][0]++;
          cov_2kmh2wqkio.s[23]++;
          last.lastFixed = true;
        } else {
          cov_2kmh2wqkio.b[8][1]++;
        }
      } else {
        cov_2kmh2wqkio.b[5][1]++;
        var sub = (cov_2kmh2wqkio.s[24]++, []);
        cov_2kmh2wqkio.s[25]++;
        colSpan = this.setColumns(sub, col, level + 1, index);
        var group = (cov_2kmh2wqkio.s[26]++, g[level]);
        cov_2kmh2wqkio.s[27]++;
        columns.push({
          name: g[level],
          key: typeof g[level] === 'string' ? (cov_2kmh2wqkio.b[9][0]++, "".concat(index, "-").concat(g[level])) : (cov_2kmh2wqkio.b[9][1]++, (cov_2kmh2wqkio.b[10][0]++, cacheGroup.get(group)) || (cov_2kmh2wqkio.b[10][1]++, cacheGroup.set(group, getUidStr()).get(group))),
          colSpan: colSpan,
          level: level,
          fixed: col.fixed,
          firstFixed: col.firstFixed,
          columns: sub
        });
      }

      cov_2kmh2wqkio.s[28]++;
      return colSpan;
    }
  }, {
    key: "resizeColgroup",
    value: function resizeColgroup(deltaX) {
      cov_2kmh2wqkio.f[2]++;

      var _ref = (cov_2kmh2wqkio.s[29]++, this.props),
          columns = _ref.columns;

      var item = (cov_2kmh2wqkio.s[30]++, columns[this.resizingIndex]);

      var _ref2 = (cov_2kmh2wqkio.s[31]++, item),
          minWidth = _ref2.minWidth,
          maxWidth = _ref2.maxWidth;

      var oWidth = (cov_2kmh2wqkio.s[32]++, parseInt(this.resizingCol.style.width, 10));
      cov_2kmh2wqkio.s[33]++;

      if ((cov_2kmh2wqkio.b[12][0]++, Number.isNaN(oWidth)) || (cov_2kmh2wqkio.b[12][1]++, oWidth === 0)) {
        cov_2kmh2wqkio.b[11][0]++;
        cov_2kmh2wqkio.s[34]++;
        oWidth = this.resizingTh.getBoundingClientRect().width;
      } else {
        cov_2kmh2wqkio.b[11][1]++;
      }

      var w = (cov_2kmh2wqkio.s[35]++, oWidth + deltaX);
      cov_2kmh2wqkio.s[36]++;

      if (isNumber(minWidth)) {
        cov_2kmh2wqkio.b[13][0]++;
        cov_2kmh2wqkio.s[37]++;
        w = Math.max(w, minWidth);
      } else {
        cov_2kmh2wqkio.b[13][1]++;
        cov_2kmh2wqkio.s[38]++;
        w = Math.max(w, MIN_RESIZABLE_WIDTH);
      }

      cov_2kmh2wqkio.s[39]++;

      if (isNumber(maxWidth)) {
        cov_2kmh2wqkio.b[14][0]++;
        cov_2kmh2wqkio.s[40]++;
        w = Math.min(w, maxWidth);
      } else {
        cov_2kmh2wqkio.b[14][1]++;
      }

      cov_2kmh2wqkio.s[41]++;
      this.resizingCol.style.width = "".concat(w, "px");
    }
  }, {
    key: "handleResize",
    value: function handleResize(type, e) {
      cov_2kmh2wqkio.f[3]++;
      cov_2kmh2wqkio.s[42]++;

      if (type === 'mousedown') {
        cov_2kmh2wqkio.b[15][0]++;
        var target = (cov_2kmh2wqkio.s[43]++, e.target);
        cov_2kmh2wqkio.s[44]++;
        this.resizingTh = getParent(target, 'th');
        cov_2kmh2wqkio.s[45]++;
        this.resizingTable = getParent(target, 'table');
        var thList = (cov_2kmh2wqkio.s[46]++, getParent(target, 'tr').children);
        var indexInTr = (cov_2kmh2wqkio.s[47]++, [].indexOf.call(thList, this.resizingTh));
        cov_2kmh2wqkio.s[48]++;
        this.resizingIndex = [].slice.call(thList, 0, indexInTr).reduce(function (total, th) {
          cov_2kmh2wqkio.f[4]++;
          var count = (cov_2kmh2wqkio.s[49]++, (cov_2kmh2wqkio.b[16][0]++, Number(th.getAttribute('colspan'))) || (cov_2kmh2wqkio.b[16][1]++, 1));
          cov_2kmh2wqkio.s[50]++;
          return total + count;
        }, 0);
        cov_2kmh2wqkio.s[51]++;
        this.resizingCol = this.resizingTable.querySelectorAll('col')[this.resizingIndex];
        cov_2kmh2wqkio.s[52]++;
        this.resizingTable.classList.add(tableClass('resizing'));
        cov_2kmh2wqkio.s[53]++;
        this.resizingTh.classList.add(tableClass('resizing-item'));
        cov_2kmh2wqkio.s[54]++;
        document.addEventListener('mousemove', this.handleMouseMove);
        cov_2kmh2wqkio.s[55]++;
        document.addEventListener('mouseup', this.handleMouseUp);
      } else {
        cov_2kmh2wqkio.b[15][1]++;
        cov_2kmh2wqkio.s[56]++;

        if (type === 'mousemove') {
          cov_2kmh2wqkio.b[17][0]++;
          var x = (cov_2kmh2wqkio.s[57]++, e.clientX);
          cov_2kmh2wqkio.s[58]++;

          if (typeof this.lastX === 'number') {
            cov_2kmh2wqkio.b[18][0]++;
            var deltaX = (cov_2kmh2wqkio.s[59]++, x - this.lastX);
            cov_2kmh2wqkio.s[60]++;
            this.resizeColgroup(deltaX);
          } else {
            cov_2kmh2wqkio.b[18][1]++;
          }

          cov_2kmh2wqkio.s[61]++;
          this.lastX = x;
        } else {
          cov_2kmh2wqkio.b[17][1]++;
          cov_2kmh2wqkio.s[62]++;

          if (type === 'mouseup') {
            cov_2kmh2wqkio.b[19][0]++;

            var _ref3 = (cov_2kmh2wqkio.s[63]++, this.props),
                onColChange = _ref3.onColChange,
                colgroup = _ref3.colgroup;

            cov_2kmh2wqkio.s[64]++;
            document.removeEventListener('mousemove', this.handleMouseMove);
            cov_2kmh2wqkio.s[65]++;
            document.removeEventListener('mouseup', this.handleMouseUp);
            cov_2kmh2wqkio.s[66]++;
            this.resizingTable.classList.remove(tableClass('resizing'));
            cov_2kmh2wqkio.s[67]++;
            this.resizingTh.classList.remove(tableClass('resizing-item'));
            cov_2kmh2wqkio.s[68]++;
            this.lastX = undefined;
            cov_2kmh2wqkio.s[69]++;

            if (onColChange) {
              cov_2kmh2wqkio.b[20][0]++;
              cov_2kmh2wqkio.s[70]++;
              onColChange(this.resizingIndex, parseInt(this.resizingCol.style.width, 10), colgroup);
            } else {
              cov_2kmh2wqkio.b[20][1]++;
            }
          } else {
            cov_2kmh2wqkio.b[19][1]++;
          }
        }
      }
    }
  }, {
    key: "createTh",
    value: function createTh(trs, col, level) {
      var _this2 = this;

      cov_2kmh2wqkio.f[5]++;

      var _ref4 = (cov_2kmh2wqkio.s[71]++, this.props),
          columnResizable = _ref4.columnResizable;

      var colTemp = (cov_2kmh2wqkio.s[72]++, col);
      var colTemp2 = (cov_2kmh2wqkio.s[73]++, col);
      var fixed = (cov_2kmh2wqkio.s[74]++, []);
      cov_2kmh2wqkio.s[75]++;

      if (col.fixed) {
        cov_2kmh2wqkio.b[21][0]++;
        cov_2kmh2wqkio.s[76]++;
        fixed.push("fixed-".concat(col.fixed));
      } else {
        cov_2kmh2wqkio.b[21][1]++;
      }

      cov_2kmh2wqkio.s[77]++;

      if (col.firstFixed) {
        cov_2kmh2wqkio.b[22][0]++;
        cov_2kmh2wqkio.s[78]++;
        fixed.push('fixed-first');
      } else {
        cov_2kmh2wqkio.b[22][1]++;
      }

      cov_2kmh2wqkio.s[79]++;

      if (col.lastFixed) {
        cov_2kmh2wqkio.b[23][0]++;
        cov_2kmh2wqkio.s[80]++;
        fixed.push('fixed-last');
      } else {
        cov_2kmh2wqkio.b[23][1]++;
      }

      var _ref5 = (cov_2kmh2wqkio.s[81]++, this.props),
          sorter = _ref5.sorter,
          onSortChange = _ref5.onSortChange,
          data = _ref5.data,
          datum = _ref5.datum,
          showSelectAll = _ref5.showSelectAll,
          disabled = _ref5.disabled,
          treeColumnsName = _ref5.treeColumnsName,
          treeCheckAll = _ref5.treeCheckAll;

      var isEmpty = (cov_2kmh2wqkio.s[82]++, !((cov_2kmh2wqkio.b[24][0]++, data) && (cov_2kmh2wqkio.b[24][1]++, data.length)));
      var align = (cov_2kmh2wqkio.s[83]++, (cov_2kmh2wqkio.b[25][0]++, colTemp.align) && (cov_2kmh2wqkio.b[25][1]++, "align-".concat(colTemp.align)));
      var ignoreBorderRight = (cov_2kmh2wqkio.s[84]++, (cov_2kmh2wqkio.b[26][0]++, this.rightBorderRecord[col.key]) && (cov_2kmh2wqkio.b[26][1]++, 'ignore-right-border'));
      var resize = (cov_2kmh2wqkio.s[85]++, (cov_2kmh2wqkio.b[28][0]++, level === 0) && (cov_2kmh2wqkio.b[28][1]++, !isEmpty) && (cov_2kmh2wqkio.b[28][2]++, columnResizable) && (cov_2kmh2wqkio.b[28][3]++, col.columnResizable !== false) ? (cov_2kmh2wqkio.b[27][0]++,
      /*#__PURE__*/
      React.createElement("span", {
        onMouseDown: this.handleMouseDown,
        className: tableClass('resize-spanner'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 9
        }
      })) : (cov_2kmh2wqkio.b[27][1]++, null));
      cov_2kmh2wqkio.s[86]++;

      if (colTemp.title) {
        cov_2kmh2wqkio.b[29][0]++;
        cov_2kmh2wqkio.s[87]++;
        trs[level].push(
        /*#__PURE__*/
        React.createElement("th", {
          className: classnames(tableClass.apply(void 0, [(cov_2kmh2wqkio.b[30][0]++, level > 0) && (cov_2kmh2wqkio.b[30][1]++, 'condensed'), align, ignoreBorderRight].concat(fixed)), col.className),
          rowSpan: this.columnLevel - level + 1,
          key: col.key,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 165,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass((cov_2kmh2wqkio.b[31][0]++, colTemp.sorter) && (cov_2kmh2wqkio.b[31][1]++, 'has-sorter')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 174,
            columnNumber: 13
          }
        }, typeof colTemp.title === 'function' ? (cov_2kmh2wqkio.b[32][0]++, colTemp.title(data)) : (cov_2kmh2wqkio.b[32][1]++, colTemp.title)), (cov_2kmh2wqkio.b[33][0]++, colTemp.sorter) && (cov_2kmh2wqkio.b[33][1]++,
        /*#__PURE__*/
        React.createElement(Sorter, Object.assign({}, colTemp, {
          sorter: colTemp.sorter,
          current: sorter,
          keyStr: col.key,
          onChange: onSortChange,
          renderSorter: this.props.renderSorter,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176,
            columnNumber: 15
          }
        }))), resize)));
        cov_2kmh2wqkio.s[88]++;
        return;
      } else {
        cov_2kmh2wqkio.b[29][1]++;
      }

      cov_2kmh2wqkio.s[89]++;

      if (colTemp.type === 'checkbox') {
        cov_2kmh2wqkio.b[34][0]++;
        cov_2kmh2wqkio.s[90]++;
        trs[level].push(
        /*#__PURE__*/
        React.createElement("th", {
          key: "checkbox",
          rowSpan: trs.length,
          className: classnames(tableClass.apply(void 0, ['checkbox'].concat(fixed)), colTemp.className),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 195,
            columnNumber: 9
          }
        }, (cov_2kmh2wqkio.b[35][0]++, showSelectAll) && (cov_2kmh2wqkio.b[35][1]++,
        /*#__PURE__*/
        React.createElement(CheckboxAll, {
          disabled: disabled === true,
          data: data,
          datum: datum,
          treeColumnsName: treeCheckAll ? (cov_2kmh2wqkio.b[36][0]++, treeColumnsName) : (cov_2kmh2wqkio.b[36][1]++, undefined),
          col: col,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201,
            columnNumber: 13
          }
        }))));
        cov_2kmh2wqkio.s[91]++;
        return;
      } else {
        cov_2kmh2wqkio.b[34][1]++;
      }

      var style = (cov_2kmh2wqkio.s[92]++, typeof colTemp2.name === 'string' ? (cov_2kmh2wqkio.b[37][0]++, undefined) : (cov_2kmh2wqkio.b[37][1]++, {
        padding: 0
      }));
      cov_2kmh2wqkio.s[93]++;
      trs[level].push(
      /*#__PURE__*/
      React.createElement("th", {
        className: classnames(tableClass.apply(void 0, ['center', 'condensed', ignoreBorderRight].concat(fixed)), col.className),
        colSpan: colTemp2.colSpan,
        key: col.key,
        style: style,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 216,
          columnNumber: 7
        }
      }, colTemp2.name, resize));
      cov_2kmh2wqkio.s[94]++;

      if (colTemp2.columns) {
        cov_2kmh2wqkio.b[38][0]++;
        cov_2kmh2wqkio.s[95]++;
        colTemp2.columns.forEach(function (c) {
          cov_2kmh2wqkio.f[6]++;
          cov_2kmh2wqkio.s[96]++;
          return _this2.createTh(trs, c, level + 1);
        });
      } else {
        cov_2kmh2wqkio.b[38][1]++;
      }
    }
  }, {
    key: "ignoreRightBorder",
    value: function ignoreRightBorder(column) {
      cov_2kmh2wqkio.f[7]++;
      var columnGroup = (cov_2kmh2wqkio.s[97]++, column);
      cov_2kmh2wqkio.s[98]++;
      this.rightBorderRecord[column.key] = true;
      cov_2kmh2wqkio.s[99]++;

      if (columnGroup.columns) {
        cov_2kmh2wqkio.b[39][0]++;
        cov_2kmh2wqkio.s[100]++;
        this.ignoreRightBorder(columnGroup.columns[columnGroup.columns.length - 1]);
      } else {
        cov_2kmh2wqkio.b[39][1]++;
      }
    }
  }, {
    key: "formatColumns",
    value: function formatColumns() {
      var _this3 = this;

      cov_2kmh2wqkio.f[8]++;
      cov_2kmh2wqkio.s[101]++;
      this.columnLevel = 0;
      var columns = (cov_2kmh2wqkio.s[102]++, []);
      cov_2kmh2wqkio.s[103]++;
      this.props.columns.forEach(function (col, index) {
        cov_2kmh2wqkio.f[9]++;
        cov_2kmh2wqkio.s[104]++;

        _this3.setColumns(columns, col, 0, index);
      });
      cov_2kmh2wqkio.s[105]++;
      this.rightBorderRecord = {};
      cov_2kmh2wqkio.s[106]++;

      if ((cov_2kmh2wqkio.b[41][0]++, columns.length > 0) && (cov_2kmh2wqkio.b[41][1]++, this.props.bordered)) {
        cov_2kmh2wqkio.b[40][0]++;
        cov_2kmh2wqkio.s[107]++;
        this.ignoreRightBorder(columns[columns.length - 1]);
      } else {
        cov_2kmh2wqkio.b[40][1]++;
      }

      cov_2kmh2wqkio.s[108]++;
      return columns;
    }
  }, {
    key: "formatTrs",
    value: function formatTrs() {
      var _this4 = this;

      cov_2kmh2wqkio.f[10]++;
      var columns = (cov_2kmh2wqkio.s[109]++, this.formatColumns());
      var trs = (cov_2kmh2wqkio.s[110]++, []);
      cov_2kmh2wqkio.s[111]++;

      for (var i = 0; i <= this.columnLevel; i++) {
        cov_2kmh2wqkio.s[112]++;
        trs.push([]);
      }

      cov_2kmh2wqkio.s[113]++;
      columns.forEach(function (col) {
        cov_2kmh2wqkio.f[11]++;
        cov_2kmh2wqkio.s[114]++;
        return _this4.createTh(trs, col, 0);
      });
      cov_2kmh2wqkio.s[115]++;
      return trs;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      cov_2kmh2wqkio.f[12]++;
      var trs = (cov_2kmh2wqkio.s[116]++, this.formatTrs());
      cov_2kmh2wqkio.s[117]++;
      return (
        /*#__PURE__*/
        React.createElement("thead", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 269,
            columnNumber: 7
          }
        }, trs.map(function (tr, i) {
          cov_2kmh2wqkio.f[13]++;
          cov_2kmh2wqkio.s[118]++;
          return (
            /*#__PURE__*/
            React.createElement("tr", {
              key: i,
              __self: _this5,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 271,
                columnNumber: 11
              }
            }, tr)
          );
        }))
      );
    }
  }]);

  return Thead;
}(PureComponent);

Thead.defaultProps = {
  showSelectAll: true
};
export default Thead;